import React, { lazy } from 'react';
import { Button } from './ui/Button';
export function AboutBanner() {
  return <section className="relative py-24 lg:py-32 font-heading overflow-hidden" data-id="element-15">
      {/* Video Background */}
      <div className="absolute inset-0 w-full h-full z-0" data-id="element-16">
        <video className="w-full h-full object-cover hidden md:block" autoPlay muted loop playsInline loading="lazy" data-id="element-17">
          <source src="https://vid.cdn-website.com/d7afec65/videos/4cCFAEbwSyWTWX4NDfwb_dji_fly_20251029_004752_0451_1762905980636_video-v.mp4" type="video/mp4" data-id="element-18" />
        </video>

        {/* Mobile Fallback Poster with Parallax */}
        <div className="w-full h-full bg-cover bg-center md:hidden" style={{
        backgroundImage: 'url("https://lirp.cdn-website.com/d7afec65/dms3rep/multi/opt/4cCFAEbwSyWTWX4NDfwb_dji_fly_20251029_004752_0451_1762905980636_video.v2.0000000-1920w.jpg")'
      }} data-id="element-19" />
      </div>

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/60 z-10" data-id="element-20" />

      {/* Content */}
      <div className="relative z-20 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-21">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6 uppercase tracking-tight leading-tight" data-id="element-22">
          Veteran-Owned. FAA-Certified.
          <br className="hidden md:block" data-id="element-23" /> Arizona & SoCal Proud.
        </h2>

        <p className="text-white/90 text-lg md:text-xl leading-relaxed mb-10 max-w-3xl mx-auto" data-id="element-24">
          Busy Drones Cleaners combines military discipline with advanced drone
          technology to deliver precise exterior cleaning services. Based in
          Yuma, AZ, our team serves commercial and residential clients across
          Arizona and Southern California — from hotels and HOAs to
          single-family homes. We focus on quality workmanship, safety, and
          long-term property care.
        </p>

        <Button className="bg-[#F5A623] hover:bg-[#E09520] text-[#1B3A5C] font-bold text-lg h-14 px-10 rounded-lg shadow-lg" data-id="element-25">
          Learn About Us
        </Button>
      </div>
    </section>;
}